import { CSSProperties, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Icon } from '@musinsa/mwms-ds'
import type { IconNames } from '@musinsa/mwms-ds'

type BannerVariant = 'info' | 'warning' | 'critical'

interface BannerProps {
  variant?: BannerVariant
  className?: string
  style?: CSSProperties
}

const VARIANT_TOKEN: Record<BannerVariant, { bg: string; border: string; iconColor: string; iconName: IconNames }> = {
  info: {
    bg: 'rgba(224, 224, 224, 0.2)',
    border: '#ebebeb',
    iconColor: '#8a8a8a',
    iconName: 'tip',
  },
  warning: {
    bg: '#fff4e5',
    border: 'rgba(255, 203, 133, 0.5)',
    iconColor: '#fa9200',
    iconName: 'alert',
  },
  critical: {
    bg: '#ffecec',
    border: 'rgba(255, 171, 165, 0.3)',
    iconColor: '#d50f0e',
    iconName: 'circle-close',
  },
}

function Banner({ variant = 'info', className, style, children }: PropsWithChildren<BannerProps>) {
  const { bg, border, iconColor, iconName } = VARIANT_TOKEN[variant]
  return (
    <Root className={className} style={style} $bg={bg} $border={border}>
      <Icon fill name={iconName} size={16} style={{ color: iconColor, flexShrink: 0 }} />
      <Message>{children}</Message>
    </Root>
  )
}

const Root = styled.div<{ $bg: string; $border: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid ${({ $border }) => $border};
  border-radius: 4px;
  background-color: ${({ $bg }) => $bg};
`

const Message = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  color: #000;
  word-break: keep-all;
`

export default Banner
